module.exports = __webpack_public_path__ + "img/snow_light.6c12541b.svg";